
export const createAgaroseGel = (data) => ({
    type: "CREATE_AGAROSE_GEL", payload: data
  });

  
//---GEL------------------------------------------:
export const createGel = data => {
  //data = {id, description, type}
  return { type: "CREATE_GEL", payload: data };
};

export const setGel = data => {
  //data = {type, concentration, description}
  return { type: "SET_GEL", payload: data };
};

export const setGelOnShelf = data => {
  //data = {id, onShelf}
  return { type: "SET_GEL_ON_SHELF", payload: data };
};

export const setGelLane = data => {
  //data = {id, laneNumber, laneData}
  return { type: "SET_GEL_LANE", payload: data };
};

export const makeGelImgConfig = data => {
  //data = {id}
  return { type: "MAKE_GEL_IMG_CONFIG", payload: data };
};

export const setGelInScene = data => {
  //data = {type, inScene}
  return { type: "SET_GEL_IN_SCENE", payload: data };
};

export const setGelHeld = data => {
  //data = {id, held}
  return { type: "SET_GEL_HELD", payload: data };
};

export const setGelPrediction = data => {
  //data = {id, held}
  return { type: "SET_GEL_PREDICTION", payload: data };
};

export const setGelResult = data => {
  //data = {id, held}
  return { type: "SET_GEL_RESULT", payload: data };
};

export const setGelActiveLane = data => {
  //data = {id, lane}
  return { type: "SET_GEL_ACTIVE_LANE", payload: data };
};

export const setPredictionBandHeight = data => {
  // data = {id, lane, label, height}
  return { type: "SET_PREDICTION_BAND_HEIGHT", payload: data };
};

export const setPredictionAllHeights = data => {
  // data = {id, heights}
  return { type: "SET_PREDICTION_ALL_HEIGHTS", payload: data };
};

export const setDropdownPrediction = data => {
  // data = {id, choice}
  return { type: "SET_DROPDOWN_PREDICTION", payload: data };
};

export const setPredictionLaneVisible = data => {
  // data = {id, lane, visible}
  return { type: "SET_PREDICTION_LANE_VISIBLE", payload: data };
};

//Set whether the pipette controls are displayed or not
export const setGelControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_GEL_CONTROLS_VISIBLE", payload: data}
}


